import React, { useContext, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Box, Button, Grid, makeStyles } from "@material-ui/core/";
import { Link, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import UserContext from "../../../context/User/UserContext";
import commonMethods from "../../../utils/commonMethods";
import DnerhsApi from "../../../api/DnerhsApi";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(),
  },
}));

const List = () => {
  const classes = useStyles();
  const { userData } = useContext(UserContext);
  const isAdmin = userData && userData.role.descripcion === "ROLE_ADMIN";
  const params = useParams();

  const handleDownloadReport = async () => {
    let nameVar="convenio";
    let urlconvenio = `/convenios/${params.convenioId}`; 
    const {data : responseConvenio} = await DnerhsApi(urlconvenio);
    const categoria = responseConvenio.categoria;
    const tipo = responseConvenio.institucionFormadora.tipoInstitucionFormadora;


    /*let url = `/convenios/carrerasprogramas/${params.convenioId}/carreras-programas`;
    const response = await DnerhsApi.get(url);
    console.log("response load data", response);
    console.log("response data length", response.data.length)

    if(responseConvenio.categoria==="Grado" && responseConvenio.institucionFormadora.tipoInstitucionFormadora==="Pública"){
      nameVar="convenio_grado_publica";
    }
    if(responseConvenio.categoria==="Grado" && responseConvenio.institucionFormadora.tipoInstitucionFormadora==="Privada"){
      nameVar="convenio_grado_privada";
    }
    if(responseConvenio.categoria==="Pregrado" && responseConvenio.institucionFormadora.tipoInstitucionFormadora==="Pública"){
      nameVar="convenio_tecnicatura_publica";
    }
    if(responseConvenio.categoria==="Pregrado" && responseConvenio.institucionFormadora.tipoInstitucionFormadora==="Privada"){
      nameVar="convenio_tecnicatura_privada";
    }
    if(responseConvenio.categoria==="Postgrado" && responseConvenio.institucionFormadora.tipoInstitucionFormadora==="Pública"){
      if(response.data.length >= 18 && response.data.length <=25 ){
        nameVar="convenio_postgrado_publica";
      } else if(response.data.length >= 11 && response.data.length <=17 ){
        nameVar="convenio_postgrado_publica_2";
      } else if(response.data.length >= 1 && response.data.length <=10 ){
        nameVar="convenio_postgrado_publica_3";
      } else {
        nameVar="convenio_postgrado_publica";
      }
    }   
    if(responseConvenio.categoria==="Postgrado" && responseConvenio.institucionFormadora.tipoInstitucionFormadora==="Privada"){
      if(response.data.length >= 18 && response.data.length <=25 ){
        nameVar="convenio_postgrado_privada";
      } else if(response.data.length >= 11 && response.data.length <=17 ){
        nameVar="convenio_postgrado_privada_2";
      } else if(response.data.length >= 1 && response.data.length <=10 ){
        nameVar="convenio_postgrado_privada_3";
      } else {
        nameVar="convenio_postgrado_privada";
      }
    }*/

   let enlace = `${process.env.REACT_APP_DNERHS_REPORTES_PROTOCOL}://${process.env.REACT_APP_DNERHS_REPORTES_HOST}/convenio/?name=${nameVar}&convenioId=${params.convenioId}&categoria=${categoria}&tipo=${tipo}`;
   // const enlace = `http://localhost:9080/reportes/?name=convenio&convenioId=${params.convenioId};`;

    
    commonMethods.downloadFile(enlace, nameVar+".pdf", true);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          color="primary"
          align="center"
          className={classes.title}
        >
          Descargar convenio
        </Typography>
        <Paper>
          <Box p={1}>
            <Table size="small">
              <TableBody>
                <TableRow key={"docs"}>
                  <TableCell align="left">
                    Descarga del convenio para firma manuscrita de la máxima
                    autoridad
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className={classes.button}
                      onClick={() => handleDownloadReport()}
                    >
                      Descargar
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Grid item className={classes.button}>
                <Button
                  variant="contained"
                  color="default"
                  component={Link}
                  to={`/convenios/editar/${params.convenioId}`}
                >
                 Atrás
                </Button>
              </Grid>
            </Grid>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnVisibilityChange
              draggable
              pauseOnHover
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default List;
